import React from 'react';
import AppModal from '../organisms/CustomModal';
import Button from './Button';

interface DocumentViewerProps {
    fileUrl: string;
    fileName: string;
    closeModal: any
}

const DocumentViewer: React.FC<DocumentViewerProps> = ({ fileUrl, fileName, closeModal }) => {
    const handleDownload = async () => {
        try {
            const res = await fetch(fileUrl);
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        } catch (error) {
            window.open(fileUrl, '_blank');
        }
    };

    return (
        <AppModal
            modalStyle="bg-DarkBg10 w-full max-w-4xl mobile:w-[95%] h-fit max-h-[90vh] mobile:min-h-[30vh] z-30 right-0 left-0 top-24 mobile:top-16 mobile:right-0 mobile:left-0 mx-auto animate-slide_down2 mobile:animate-fade_in rounded-xl mobile:rounded-lg shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition ease-in-out duration-500"
            backDropStyle='!bg-BackDrop_d_xl'
            contentStyle="h-fit min-h-[40vh] mobile:min-h-[30vh] p-5 mobile:p-3 flex flex-col gap-5"
            closeBtnStyle='text-Primary hidden'
        >
            <div className="document-viewer flex flex-col h-full">
                <div className="relative w-full desktop:h-[65vh] tablet:h-[55vh] mobile:h-[50vh] min-h-[300px] mobile:min-h-[250px]">
                    <iframe
                        src={fileUrl}
                        title="Resume preview"
                        className="absolute inset-0 w-full h-full border-0"
                        allowFullScreen
                    />
                </div>

                <div className='flex flex-col mobile:flex-row justify-end mobile:justify-between items-stretch mobile:items-center gap-3 mt-5 flex-shrink-0'>
                    <Button
                        btnType='submit'
                        btnText='Close'
                        btnStyle='flex w-fit mobile:w-full px-6 py-2 text-base text-Primary hover:text-Background rounded-full border border-Primary hover:!border-Primary_Accents_xl hover:bg-Primary_Accents_xl hover:border-Primary_Accents_xl transition ease-in-out duration-500'
                        handleClick={() => closeModal(false)}
                    />

                    <Button
                        btnType='submit'
                        btnText='Download'
                        btnStyle='flex w-fit mobile:w-full px-6 py-2 text-base hover:text-Background rounded-full bg-Primary text-Background rounded shadow hover:bg-Primary_Accents_3xl transition ease-in-out duration-500'
                        handleClick={handleDownload}
                    />
                </div>
            </div>
        </AppModal>
    );
};

export default DocumentViewer;